/** Query keys for ERP record provenance. Tenant-scoped like every MDM key. */
export const erpProvenanceKeys = {
  all: ['erp-provenance'] as const,
  record: (recordId: string, tenantId: string) =>
    [...erpProvenanceKeys.all, 'record', recordId, tenantId] as const,
  /** Sorted so the same page requested in a different order shares one entry. */
  batch: (recordIds: string[], tenantId: string) =>
    [
      ...erpProvenanceKeys.all,
      'batch',
      tenantId,
      [...recordIds].sort(),
    ] as const,
  syncedTypes: (tenantId: string) =>
    [...erpProvenanceKeys.all, 'synced-types', tenantId] as const,
};
